import { UpdateColumnScheduleModel, UpdateGroupScheduleModel } from 'countable@model';

export class UpdateEngagementScheduleModel {
  id: number = null;
  smufId: string = null;
  eng: number = null;
  submodule: number | null = null;
  acctYear: number = null;
  name: string = null;
  nameChange: string | null = null;
  groupLinkId: string = '';
  sortOrder: number = null;
  columns: UpdateColumnScheduleModel[] = [];
  schedules: UpdateGroupScheduleModel[] = [];
  isCollapse: boolean = false;
  isTotalHide: boolean = false;
  isTotalDescHide: boolean = false;
  uuid: string = null;
  isBSSch: boolean = false;
  disabled: boolean;
}
